import { TherapistAction } from "src/redux/actions/constant";

const intialState: object = {
    response: null,
    data: [],
    loading: false,
};

export const reassignTherapistTaskReducer = (state = intialState, action: any) => {
    switch (action.type) {
        case TherapistAction.THERAPIST_REARRANGE_TASK_SUCCESS: {
            return {
                ...state,
                response: action.payload,
                data: action.payload.data,
                loading: false,
            };
        }
        case TherapistAction.THERAPIST_REARRANGE_TASK_FAILURE: {
            return {
                ...state,
                response: action.payload,
                loading: false,
            };
        }
        case TherapistAction.THERAPIST_REARRANGE_TASK_REQUEST:
            return {
                ...state,
                loading: true,
            };

        default:
            return state;
    }
};
